import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatExpansionModule } from '@angular/material/expansion';
// Suplementos ao material
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@NgModule({
//  imports: [
//     MatFormFieldModule,
//     MatCheckboxModule,
//     MatInputModule,
//     MatRadioModule,
//     MatSelectModule,
//     MatListModule,
//     MatTabsModule,
//     MatIconModule,
//     MatDialogModule,
//     DragDropModule,
//     MatExpansionModule,
//     NgxMatSelectSearchModule
//  ],
  exports: [
    MatFormFieldModule,
    MatCheckboxModule,
    MatInputModule,
    MatRadioModule,
    MatSelectModule,
    MatListModule,
    MatTabsModule,
    MatIconModule,
    MatDialogModule,
    MatTooltipModule,
    DragDropModule,
    MatExpansionModule,
    NgxMatSelectSearchModule
  ]
})
export class MaterialModule { }
